/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskCreateDto } from '../../models/core-project-subtask-create-dto';
import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: CoreProjectSubtaskCreateDto
}

export function projectSubtasksControllerCreate(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerCreate.PATH = '/o2-core/project-subtasks/{tenant}';
